module.exports = __webpack_public_path__ + "static/media/21_pol_0_91.67.19b4f515.png";